'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsUngatedForNewHeader = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getGates = require('./getGates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIsUngatedForNewHeader = exports.getIsUngatedForNewHeader = (0, _reselect.createSelector)([_getGates.getGates], (0, _get2.default)('VisitorExperience:WidgetLookAndFeel'));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getIsUngatedForNewHeader.js
// module id = 1039
// module chunks = 2 3